import {
    createAction,
    props
} from '@ngrx/store';

const createActionName: (name: string) => string = (name: string) => {
    return `[Datiq Log] ${name}`;
};

export const log = createAction(
    createActionName('log'),
    props<{
        message: string;
        info?: unknown;
    }>()
);
export const debug = createAction(
    createActionName('debug'),
    props<{
        message: string;
        info?: unknown;
    }>()
);
export const jsError = createAction(
    createActionName('jsError'),
    props<{
        message: string;
        error: Error;
        info?: unknown;
    }>()
);
export const error = createAction(
    createActionName('error'),
    props<{
        message: string;
        info?: unknown;
    }>()
);

export const warn = createAction(
    createActionName('warn'),
    props<{
        message: string;
        info?: unknown;
    }>()
);

export const errorOtelSuccess = createAction(
    createActionName('otel error success'),
    props<{
        message: string;
        info?: unknown;
    }>()
);

export const logOtelSuccess = createAction(
    createActionName('otel log success'),
    props<{
        message: string;
        info?: unknown;
    }>()
);
export const warnOtelSuccess = createAction(
    createActionName('otel warn success'),
    props<{
        message: string;
        info?: unknown;
    }>()
);
export const debugOtelSuccess = createAction(
    createActionName('otel debug success'),
    props<{
        message: string;
        info?: unknown;
    }>()
);
export const jsErrorOtelSuccess = createAction(
    createActionName('otel js error success'),
    props<{
        message: string;
        error: Error;
        info?: unknown;
    }>()
);
